/**
 * Release notes API client — public release notes for the Settings
 * "What's New" panel.
 */

import { api } from './client';

/**
 * Get public release notes (no auth).
 */
export async function getPublicReleaseNotes() {
  return api.get('/release-notes');
}
